import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { GET_DEFAULT_TRAINING_DATA_ASYNC } from '../../WizardTrainingCampaign/constants'
import { AUTOMATED_LEVEL_BASED_TRAINING } from '../TrainingModuleStep/constants'

import {
  getDefaultTrainingDataError,
  getDefaultTrainingDataSuccess,
  getEmailPreviewError,
  getEmailPreviewSuccess,
  validateMessageStep,
} from './actions'
import { GET_EMAIL_PREVIEW_ASYNC } from './constants'

const getDefaultTrainingDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(GET_DEFAULT_TRAINING_DATA_ASYNC.INITIATE).mergeMap(() =>
    api.wizardCampaign
      .getDefaultTrainingData(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().awarenessCenter?.wizardTrainingCampaign.self.campaign.defaultLocaleId
      )
      .mergeMap((response) =>
        Observable.of(getDefaultTrainingDataSuccess(response), validateMessageStep())
      )
      .catch((error) => Observable.of(epicsErrorHandler(getDefaultTrainingDataError, error, [400])))
  )

const getEmailPreviewEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(GET_EMAIL_PREVIEW_ASYNC.INITIATE).mergeMap((action) => {
    const { data } = action.payload

    return api.wizardCampaign
      .getEmailPreview(
        {
          message: data.message,
          includeLogo: data.includeLogo,
          useDesignedImage: data.useDesignedImage,
          trainingId:
            data.trainingVideoId === AUTOMATED_LEVEL_BASED_TRAINING.id
              ? null
              : data.trainingVideoId,
          mailSignature: data.mailSignature,
          localeId: data.localeId,
          subject: data.subject,
        },
        store.getState().partnerOptions.selectedCompany?.value
      )
      .mergeMap((response) => Observable.of(getEmailPreviewSuccess(response)))
      .catch((error) => Observable.of(epicsErrorHandler(getEmailPreviewError, error, [400])))
  })

export default combineEpics(getDefaultTrainingDataEpic, getEmailPreviewEpic)
